import { ASSIGNMENTS } from 'constants/actionTypes';

const initialState = {
  metadata: null,
  companyName: null,
  isManuallyTextAssignmentReminders: null,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case ASSIGNMENTS.DIRECT_ASSIGN.RECEIVE:
      return {
        metadata: action.metadata,
        companyName: action.companyName,
        isManuallyTextAssignmentReminders:
          action.isManuallyTextAssignmentReminders,
      };
    default:
      return state;
  }
};
